module.exports = __webpack_public_path__ + "static/media/best-sel-sidebar.2951da7d.png";